import MaintenancePage from "../../components/feature/MaintenancePage";
import SEOHead from "../../components/feature/SEOHead";

const LOGO =
  "https://storage.readdy-site.link/project_files/9ee712e0-c50a-4d2b-9956-d4b4346de3f4/eac85ab3-a5b0-4245-a3a6-d3770b3bda50_DD8_Logo.png?v=1528c047acedd0efb9bae55a40478a4a";

const siteUrl = (import.meta.env.VITE_SITE_URL as string) || "https://example.com";

const schema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${siteUrl}/dd8au#website`,
  name: "DD8AU",
  url: `${siteUrl}/dd8au`,
  inLanguage: "en-AU",
  description:
    "DD8AU website is currently undergoing scheduled maintenance. We appreciate your patience while we improve your online gaming experience.",
  potentialAction: {
    "@type": "SearchAction",
    target: `${siteUrl}/dd8au?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

export default function Dd8au() {
  return (
    <>
      <SEOHead
        title="DD8AU | We'll Be Back Shortly — Maintenance Mode"
        description="DD8AU website is currently undergoing scheduled maintenance. We appreciate your patience while we improve your experience."
        keywords="DD8AU, DD8, online gaming, maintenance"
        canonicalPath="/dd8au"
        schemaJson={schema}
        ogImage={LOGO}
        ogImageAlt="DD8AU Logo"
        siteName="DD8AU"
      />
      <MaintenancePage
        logoSrc={LOGO}
        logoAlt="DD8AU Logo"
        accentColor="#00FF7F"
        glowRgb="0,255,127"
        bgFrom="#001A0D"
        whatsappLink="https://wa.me/61497817498"
        telegramLink="https://t.me/dd8austaff"
      />
    </>
  );
}
